import React from 'react'

import { Table } from '_zari/core'

const DocumentosEncontradosTable = ({ filas }) => {
  return (
    <Table
      containerId='documentos-encontrados'
      filas={filas}
      headRows={[
        { label: 'PERIODO' },
        { label: 'ORIGEN' },
        { label: 'NUM OPE' },
        { label: 'TIPO DOC' },
        { label: 'SERIE DOC' },
        { label: 'NUM DOC' },
        { label: 'CUENTA CONTABLE' },
        { label: 'MONEDA' },
        { label: 'DEBE' },
        { label: 'HABER' },
        { label: 'SOCIO RUC' },
        { label: 'SOCIO RAZON SOCIAL' }
      ]}
      maxRowsShown={20}
      rowTemplate={row => (
        <Table.Row key={row._id}>
          <Table.Cell>{row.anoMes ?? '--'}</Table.Cell>
          <Table.Cell>{row.origen ?? '--'}</Table.Cell>
          <Table.Cell>{row.numeroOperacion ?? '--'}</Table.Cell>
          <Table.Cell>{row.tipoDocumento ?? '--'}</Table.Cell>
          <Table.Cell>{row.serieDocumento ?? '--'}</Table.Cell>
          <Table.Cell>{row.numeroDocumento ?? '--'}</Table.Cell>
          <Table.Cell>{row.cuentaContable ?? '--'}</Table.Cell>
          <Table.Cell>{row.moneda ?? '--'}</Table.Cell>
          <Table.Cell>{row.debe ?? '--'}</Table.Cell>
          <Table.Cell>{row.haber ?? '--'}</Table.Cell>
          <Table.Cell>{row.rucSocio ?? '--'}</Table.Cell>
          <Table.Cell>{row.nombreSocio ?? '--'}</Table.Cell>
        </Table.Row>
      )}
    />
  )
}

export default React.memo(DocumentosEncontradosTable)
